import React from 'react';

import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { TICKET_CORPORATE_CREDIT_PATH } from '../../../../config/paths';

const TicketCorporateCreditAddCreditLineButton = ({
  ticketCorporateCreditId,
}) => (
  <Link
    className="btn btn-light border"
    to={`${TICKET_CORPORATE_CREDIT_PATH}/${ticketCorporateCreditId}/add-credit-line`}
  >
    <i className="fa fa-dollar" /> Agregar saldo
  </Link>
);

TicketCorporateCreditAddCreditLineButton.propTypes = {
  ticketCorporateCreditId: PropTypes.number.isRequired,
};

export default TicketCorporateCreditAddCreditLineButton;
